<template>
  <NodeHome v-if="node" v-bind="node" />
</template>

<script lang="ts" setup>
defineOptions({
  name: 'NodePageHome',
})

definePageMeta({
  name: 'home',
})

// Handles redirects and metatags.
const { entity: node } = await useDrupalRouteQuery('home')
await renderPageDependencies()
</script>
